import apiClient from '@/api/apiClient';
import { handleError, getAuthData, prepareModel, validateId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    schema: {},
    modelForm: {},
    dataCrud: [],
    isNewRecord: true,
    status: '',
  },

  getters: {
    schema: (state) => state.schema,
    modelForm: (state) => state.modelForm,
    dataCrud: (state) => state.dataCrud,
    isNewRecord: (state) => state.isNewRecord,
    status: (state) => state.status,
  },

  mutations: {
    SET_SCHEMA(state, schema) {
      state.schema = schema;
    },
    SET_RECORDS(state, { recordsData }) {
      state.modelForm = typeof recordsData?.modelForm === 'object' ? recordsData.modelForm : {};
      state.dataCrud = Array.isArray(recordsData?.dataCrud) ? recordsData.dataCrud : [];
      state.isNewRecord = Boolean(recordsData?.isNewRecord);
    },
    SET_STATUS(state, status) {
      state.status = status;
    },
  },

  actions: {
    async fetchSchema({ commit }) {
      try {
        commit('SET_STATUS', 'loading');
        const responses = await Promise.all([
          apiClient.anxALxAcademBasicSchema(),
          apiClient.catInstructionGrade(),
          apiClient.catYear(),
          apiClient.catSchoolType(),
          apiClient.catCourses(),
          apiClient.catAgeInterval(),
        ]);
        const [schemaRes, catInstructionGrade, catYear, catSchoolType, catCourses, catAgeInterval] =
          responses.map((res) => res?.data ?? {});

        let id1 = 'G';
        const resCat6 = await apiClient.catLevelDescription(id1);
        const catLevelDescriptionG = resCat6.data.data;

        let id2 = 'H';
        const resCat7 = await apiClient.catLevelDescription(id2);
        const catLevelDescriptionH = resCat7.data.data;

        if (!schemaRes.formCrud) throw new Error('Estructura de schema inválida.');
        if (!schemaRes.schemaForm) throw new Error('Estructura de schema inválida.');

        const schema = structuredClone(schemaRes);
        schema.formCrud.back_academ_instruction_grade_code.items = catInstructionGrade.data ?? [];
        schema.formCrud.back_academ_attend_year.items = catYear.data ?? [];
        schema.formCrud.back_academ_attend_age.items = catAgeInterval.data ?? [];
        schema.formCrud.back_academ_school_type.items = catSchoolType.data ?? [];
        schema.formCrud.back_academ_adaptation_level_id.items = catLevelDescriptionG;
        schema.formCrud.back_academ_relationship_peer_level_id.items = catLevelDescriptionG;
        schema.formCrud.back_academ_relationship_authority_level_id.items = catLevelDescriptionG;
        schema.formCrud.back_academ_performance_level_id.items = catLevelDescriptionH;
        schema.schemaForm.primary_affinity_high.items = catCourses.data ?? [];
        schema.schemaForm.primary_affinity_low.items = catCourses.data ?? [];
        schema.schemaForm.secondary_affinity_high.items = catCourses.data ?? [];
        schema.schemaForm.secondary_affinity_low.items = catCourses.data ?? [];
        schema.schemaForm.academy_affinity_high.items = catCourses.data ?? [];
        schema.schemaForm.academy_affinity_low.items = catCourses.data ?? [];

        commit('SET_SCHEMA', schema);
      } catch (error) {
        handleError(error, commit);
      }
    },

    async fetchRecords({ commit, rootState }) {
      try {
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        const res = await apiClient.modelANxALxAcademBasic(clinicalHistories_id, institutions_profes_id);
        const recordsData = res?.data?.data ?? [];

        commit('SET_RECORDS', { recordsData });
        commit('SET_STATUS', 'loaded');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async createRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'create');
        const preparedModel = prepareModel(rootState, model);
        await apiClient.createANxALxAcademBasic(preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async updateRecord({ commit, rootState }, { model }) {
      try {
        commit('SET_STATUS', 'update');
        const { clinicalHistories_id } = getAuthData(rootState);
        const preparedModel = prepareModel(rootState, model);
        await apiClient.updateANxALxAcademBasic(clinicalHistories_id, preparedModel);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },

    async removeRecord({ commit, rootState }, { id }) {
      try {
        commit('SET_STATUS', 'remove');
        const { clinicalHistories_id, institutions_profes_id } = getAuthData(rootState);
        validateId(id);
        await apiClient.deleteANxALxAcademBasic(id, clinicalHistories_id, institutions_profes_id);
        commit('SET_STATUS', 'success');
      } catch (error) {
        handleError(error, commit);
      }
    },
  },
};
